import { OptionItemInterface } from '../../types/interfaces'

export const createTypeSelectList = <T extends Record<string, string | number>>(
  typeEnum: T,
  enumToString: (value: T[keyof T]) => string,
): OptionItemInterface[] => {
  const arr: OptionItemInterface[] = []

  // Получаем только числовые значения enum (для string enums логика другая)
  const enumValues = Object.values(typeEnum).filter(
    (value): value is T[keyof T] => typeof value === 'number'
  ) as T[keyof T][]

  for (const item of enumValues) {
    const pattern: OptionItemInterface = {
      id: String(item),
      label: enumToString(item),
      name: enumToString(item),
      value: String(item),
    }
    arr.push(pattern)
  }
  return arr
}